<template>
  <div class="">
    <div class="wpcm-radial-progress-bar" v-show="show_progress">
      <div class="circular" v-if="collected >= 0 && needed">
        <input class="knob" ref="knob" data-fgColor="#d8281b" data-bgColor="#dddddd" data-thickness=".10" readonly
          :value="((collected / needed) * 100).toFixed(1)" /><span v-if="strings">{{ strings.completed }}</span>
      </div>
    </div>

    <!-- Show message when conditions are met -->
    <div v-if="shouldShowTargetMessage" class="wpcm-target-achieved">
      <p>{{ strings.target_achieved }}</p>
    </div>
    <!-- <div v-else> -->
      <div v-if="show_collection" class="wpcm-amount-collected">
        <span class="amount-return"><i>{{ symbol }}</i> {{ collected }}</span>
        <span v-if="strings">{{ strings.collection }}</span>
      </div>
      <div class="wpcm-amount-needed" v-if="show_collection">
        <span class="amount-return"><i>{{ symbol }}</i> {{ needed }}</span>
        <span v-if="strings">{{ strings.target }}</span>
      </div>
    </div>
  <!-- </div> -->
</template>

<script>
const $ = jQuery;
export default {
  props: {
    strings: Object,
    show_title: Boolean,
    top_title: String,
    title: String,
    tagline: String,
    collected: Number,
    needed: Number,
    symbol: String,
    show_progress: Boolean,
    show_collection: Boolean,
    show_end_campaign: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    shouldShowTargetMessage() {
      // console.log('show_end_campaign:', this.show_end_campaign);
      // console.log('collected:', this.collected);
      // console.log('needed:', this.needed);
      return this.show_end_campaign && this.collected >= this.needed;
    }
  },
  mounted() {
    if (this.show_progress) {
      this.knob();
    }
  },
  methods: {
    knob() {
      if ($.fn.knob !== undefined) {
        $(this.$refs.knob).knob();
      }
    }
  }
};
</script>

<style>
.wpcm-target-achieved {
  margin: 15px 0;
  padding: 10px;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  border-radius: 4px;
  color: #155724;
  text-align: center;
}
</style>